import { SVGProps } from "react"
const BuildingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.58269 15.0001H3.4577C2.26604 15.0001 1.66602 14.4001 1.66602 13.2084V3.45844C1.66602 2.26677 2.26604 1.66675 3.4577 1.66675H7.04103C8.23269 1.66675 8.83266 2.26677 8.83266 3.45844V5.00008"
      stroke={props.color || "#011727"}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.4756 7.01665V16.3167C14.4756 17.6583 13.809 18.3333 12.4673 18.3333H7.60064C6.25897 18.3333 5.58398 17.6583 5.58398 16.3167V7.01665C5.58398 5.67499 6.25897 5 7.60064 5H12.4673C13.809 5 14.4756 5.67499 14.4756 7.01665Z"
      stroke={props.color || "#011727"}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.167 5.00008V3.45844C11.167 2.26677 11.767 1.66675 12.9586 1.66675H16.542C17.7336 1.66675 18.3336 2.26677 18.3336 3.45844V13.2084C18.3336 14.4001 17.7336 15.0001 16.542 15.0001H14.4753"
      stroke={props.color || "#011727"}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33398 9.16675H11.6673"
      stroke={props.color || "#011727"}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33398 11.6667H11.6673"
      stroke={props.color || "#011727"}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 18.3333V15.8333"
      stroke={props.color || "#011727"}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
export default BuildingIcon
